import { router, useLocalSearchParams } from 'expo-router';
import * as React from 'react';
import { useEffect } from 'react';
import { FullScreenSpinner, SafeAreaView } from 'smoothie';

import { isEmpty } from '../../../common/misc';
import { useAuthedUser } from '../../../common/providers/AuthedUserProvider';
import LogRocketFacade from '../../../logger/log-rocket/LogRocketFacade';
import { captureMessage } from '../../../logger/Logger';
import { KYCVerificationStatus } from '../../types/BankAccount';

const AcceptInvite = () => {
    LogRocketFacade.tagPage('AcceptInvite');

    const { userId, bankAccountId } = useLocalSearchParams<{
        userId: string;
        bankAccountId: string;
    }>();

    const user = useAuthedUser();

    useEffect(() => {
        if (user.syncteraKycStatus === KYCVerificationStatus.ACCEPTED) {
            // jointInviteBankAccountId will ensure user skips account ownership selection and just accepts disclosures
            router.replace({
                pathname: '/banking/onboarding/space-ownership',
                params: { jointInviteBankAccountId: bankAccountId },
            });
        } else {
            // First go through KYC
            router.replace({
                pathname: '/banking/kyc',
                params: { jointInviteBankAccountId: bankAccountId },
            });
        }
    }, [user.syncteraKycStatus]);

    if (isEmpty(userId) || isEmpty(bankAccountId)) {
        captureMessage(
            'Missing userId or bankAccountId on accept joint invite page',
        );
        router.navigate('/');
    }

    return (
        <SafeAreaView>
            <FullScreenSpinner />
        </SafeAreaView>
    );
};

export default AcceptInvite;
